import { render, staticRenderFns } from "./_StockUpUsageChart.vue?vue&type=template&id=19707946&scoped=true"
import script from "./_StockUpUsageChart.vue?vue&type=script&lang=js"
export * from "./_StockUpUsageChart.vue?vue&type=script&lang=js"
import style0 from "./_StockUpUsageChart.vue?vue&type=style&index=0&id=19707946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19707946",
  null
  
)

export default component.exports